import { render, staticRenderFns } from "./CardHardwares.vue?vue&type=template&id=22e49a32"
import script from "./CardHardwares.vue?vue&type=script&lang=js"
export * from "./CardHardwares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports